const messages = require('../../utils/constants');

function parseAuthentication(auth) {
  if (auth != null && auth.ret != null) {
    if (auth.ret === 0) {
      return {
        returnCode: auth.ret,
        authSuccess: auth.ret === 0,
        authHeader: auth.jwt,
        sessionId: auth.seskey,
        passwordExpired: auth.indchp != "0",
        lastSession: auth.lastSession,
        message: ""
      };
    } else {
      return {
        returnCode: auth.ret,
        authSuccess: false,
        message: messages[auth.ret] == null ? messages['1003'] : messages[auth.ret]
      }
    }
  } else {
    return {
      returnCode: auth.ret,
      authSuccess: false,
      message: messages["invalid-access"]
    };
  }
}

function parseDeviceValidation(auth) {
  // console.log("parseDeviceValidation", auth);
  if (auth != null && auth.ret != null) {
    return {
      authSuccess: auth.ret === 0,
      authHeader: auth.jwt,
      passwordExpired: auth.indchp != "0",
      lastSession: auth.lastSession,
      message: "",
      sessionActive: auth.sessionActive ? auth.sessionActive : false,
      language: auth.lng
    };
  } else {
    const oMessage = auth.message != null ? auth.message : messages['1003'];
    return {
      authSuccess: false,
      message: oMessage
    };
  }
}

function parseDeviceValidationBiometric(auth) {
  if (auth != null && auth.ret != null) {
    if (auth.ret === 0) {
      return {
        authSuccess: auth.ret === 0,
        authHeader: auth.jwt,
        passwordExpired: auth.indchp != "0",
        lastSession: auth.lastSession,
        message: "",
        sessionActive: auth.sessionActive ? auth.sessionActive : false,
        language: auth.lng,
        eCredPin: auth.eCredPin,
        eCredPwd: auth.eCredPwd,
        isPinMailerEngaged : auth.isPinMailerEngaged ? auth.isPinMailerEngaged : false 
      };
    } else {
      return {
        returnCode: auth.ret,
        authSuccess: false,
        message: messages[auth.ret] == null ? messages['1003'] : messages[auth.ret]
      }
    }
  } else {
    const oMessage = auth.message != null ? auth.message : messages['1003'];
    return {
      authSuccess: false,
      message: oMessage
    };
  }
}

function parseEncryptionKey(encryptionKey) {
  if (encryptionKey != null && encryptionKey.ret != null) {
    return {
      encryptionKeySuccess: encryptionKey.ret === 0,
      randomNum: encryptionKey.randnr,
      publicKey: encryptionKey.pubkey,
      dummySesKey: encryptionKey.seskey,
      encryptionMSG: ""
    };
  } else {
    return {
      encryptionKeySuccess: false,
      encryptionMSG: messages["error-encryption-phonline"]
    };
  }
}

function parseChangePassword(auth) {
  if (auth != null && auth.ret != null) {
    const oStatus = auth.ret != null ? auth.ret === 0 : false;
    const oMessage = oStatus ? '' : messages[auth.ret] == null ? messages['error-pwd-update'] : messages[auth.ret];
    return {
      returnCode: auth.returnCode,
      changePasswordSuccess: oStatus,
      message: oMessage
    };
  } else {
    return {
      returnCode: auth.returnCode,
      changePasswordSuccess: false,
      message: messages["invalid-access"]
    };
  }
}

function parseEnrollDevice(enrollDevice) {
  const deviceToken = enrollDevice ? enrollDevice.deviceToken ? enrollDevice.deviceToken : '' : '';
  return {
    deviceToken: deviceToken
  };
}

function serviceFactory({ api }) {
  const getAuthentication = ({ userId, password, dummySesKey }) =>
    api
      .getAuthentication(userId, password.slice(10), dummySesKey.slice(12))
      .then(parseAuthentication)
      .catch(parseAuthentication);

  const getAuthenticationWithDevice = ({ userId, password, dummySesKey, deviceInfo }) =>
    api
      .getAuthentication(userId, password.slice(10), dummySesKey.slice(12), deviceInfo.slice(4))
      .then(parseAuthentication)
      .catch(parseAuthentication);

  const getDeviceValidation = ({ userId, deviceId, deviceToken }) => {
    const cleanDeviceId = deviceId.slice(9);
    const cleanDeviceToken = deviceToken.slice(12);
    return api.getDeviceValidation(userId, cleanDeviceId, cleanDeviceToken)
      .then(parseDeviceValidation);
  };

  const getDeviceValidationWithDevice = ({ deviceInfo, userId, deviceId, deviceToken }) => {
    const cleanDeviceId = deviceId.slice(9);
    const cleanDeviceToken = deviceToken.slice(12);
    const cleanDeviceInfo = deviceInfo.slice(4);

    return api.getDeviceValidation(userId, cleanDeviceId, cleanDeviceToken, cleanDeviceInfo)
      .then(parseDeviceValidation);
  };

  const getDeviceValidationWithDeviceBiometric = ({ deviceInfo, userId, deviceId, deviceToken }) => {
    const cleanDeviceId = deviceId.slice(9);
    const cleanDeviceToken = deviceToken.slice(12);
    const cleanDeviceInfo = deviceInfo.slice(4);

    return api.getDeviceValidation(userId, cleanDeviceId, cleanDeviceToken, cleanDeviceInfo)
      .then(parseDeviceValidationBiometric);
  };

  const getEncryptionKey = ({ userId, type, metaData }) =>
    api.getEncryptionKey(userId, type, metaData).then(parseEncryptionKey);

  const changePassword = ({ password, metaData }) =>
    api.changePassword(password.slice(10), metaData)
      .then(parseChangePassword);

  const getEnrollDevice = ({ userId, deviceId, metaData }) => {
    const cleanDeviceId = deviceId.slice(7);
    return api.getEnrollDevice(userId, cleanDeviceId, metaData)
      .then(parseEnrollDevice)
      .catch(parseEnrollDevice);
  };

  const getDisenrollDevice = ({ userId, deviceId, metaData }) => {
    const cleanDeviceId = deviceId.slice(7);
    return api.getDisenrollDevice(userId, cleanDeviceId, metaData).then(() => ({ res: 'ok' }));
  };

  return {
    getAuthentication,
    getAuthenticationWithDevice,
    getDeviceValidation,
    getDeviceValidationWithDevice,
    getEncryptionKey,
    changePassword,
    getEnrollDevice,
    getDisenrollDevice,
    getDeviceValidationWithDeviceBiometric
  };
}

module.exports = serviceFactory;
